<div class="cursor-pointer"
     [ngClass]="getClass()"
     (mouseover)="onHover(true)" (mouseout)="onHover(false)" (click)="onClick()"></div>
